import React from 'react';
import PropTypes from 'prop-types';
import { parsePrice } from '@utils/price-helpers';
import AffirmIcon from '@components/icons/AffirmIcon';

const RailCheckout = ({ price, isMobile, isDesktop }) => {
	return (
		<div className={`rail__checkout sdss flex-column ${isMobile ? 'mobile-only ' : isDesktop ? 'desktop-only ' : ''}`}>
			<div className='d-flex align-items-baseline justify-content-between w-100 flex-wrap'>
				<p className='pt-2 d-flex label'>
					Subtotal:
					<span data-test='subtotal' className='cart-total-price button pl-2'>
						${parsePrice(price)}
					</span>
				</p>
				<p
					data-test='split-payments'
					className='pt-2 button button-small blue-text pair-affirm'
					data-page-type='cart'
					data-amount={price}
				>
					or 4 payments of ${(price / 4 / 100).toFixed(2)} with <AffirmIcon fill='#3431DC' />
				</p>
			</div>
			<a href='/checkout' data-checkout className='mt-3 pair-btn pair-btn__primary w-100'>
				Checkout
			</a>
		</div>
	);
};

RailCheckout.propTypes = {
	price: PropTypes.number.isRequired,
	isMobile: PropTypes.bool,
	isDesktop: PropTypes.bool,
};

export default RailCheckout;
